(function ($, window) {
	'use strict';

	$(function () {
		Array.from(document.querySelectorAll('.js-alert')).forEach(alertSystem => {
			const closeButton = alertSystem.querySelector('.js-alert__close');
			let alertString = '';

			// Check if we've got an alert cookie.
			if (Cookies.get('alert-viewed')) {
				alertString = `${Cookies.get('alert-viewed')},`;
			}

			closeButton.addEventListener('click', (ev) => {
				ev.preventDefault();
				// Get the hash from the data attributes.
				const alertHash = alertSystem.dataset.alertHash;

				// Temporarily close it.
				alertSystem.style.marginTop = `${alertSystem.offsetHeight * -1}px`;

				// Then remove it.
				setTimeout(() => {
					alertSystem.parentNode.removeChild(alertSystem);
				}, 300);

				// Then add a cookie so we don't render it in WP anymore
				Cookies.set('alert-viewed', `${alertString}${alertHash}`);

				// Fire an event our mobile menu listens for
				const closeEvent = new CustomEvent('close_alert');
				window.dispatchEvent(closeEvent);
			});
		});
	});
})(jQuery, window);
